import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["query", "row"]

  filter() {
    const query = this.queryTarget.value.trim().toLowerCase()

    this.rowTargets.forEach((row) => {
      row.hidden = !row.dataset.stateName.includes(query)
    })
  }
}
